import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { AccessControl } from '../../../components';
import { CrmJobsAccess, useCrmJobsAuthz } from '../../../hooks/useCrmJobsAuthz';
import CrmJobList from '../components/CrmJobList';

const CRMJobsRoutes = () => {
  const isAuthorizedViewCrmJobsListing = useCrmJobsAuthz(CrmJobsAccess.VIEW_CRM_JOB_LISTING_ALL);
  console.log(isAuthorizedViewCrmJobsListing);

  const AccessRestricted = (
    <Box mt={2}>
      <AccessControl />
    </Box>
  );

  return (
    <Routes>
      <Route path="" element={isAuthorizedViewCrmJobsListing ? <CrmJobList /> : AccessRestricted} />
    </Routes>
  );
};

export default CRMJobsRoutes;
